import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import {
    FormControlLabel, Checkbox, Typography, FormControl, MenuItem, InputLabel, Select,
    Paper, IconButton, Box, TextField, InputAdornment, ListItemText, OutlinedInput,
    Tooltip
} from '@mui/material';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from '../../../../GlobalFunction/checkAndLock';
import UnLock from '../../../../GlobalFunction/UnLock';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import { useReactToPrint } from 'react-to-print';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { keyframes } from '@emotion/react';
import {
    getRoomMasterdropdata,
    getShiftMasterdropdata,
    getYojnaMasterdropdata,
    getYojnaMasteTaskdrp,
    getYojnaMastearedrp
} from '../../../../Api/PropertyMst/Api';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';
import WeeklywisePrint from './WeeklywisePrint';
import axiosInstanceForPG from '../../../../lib/axiosFormPG';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const DAYS_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Rotate the hourglass
const fillLiquid = keyframes`
  0% { transform: translateY(100%); }
  100% { transform: translateY(0%); }
`;

const rotate360 = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const MemoizedCheckbox = React.memo(({ checked, onChange, disabled, indeterminate, size = "small", sx = {} }) => (
    <Checkbox
        size={size}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        indeterminate={indeterminate}
        sx={{
            padding: '2px',
            margin: 0,
            '&.Mui-checked': { color: '#4CAF50' },
            '&.MuiCheckbox-indeterminate': { color: '#4CAF50' },
            ...sx
        }}
    />
));

const TaskRow = React.memo(({ index, style, data }) => {
    const {
        filteredTasks,
        isFormDisabled,
        handleDayCheck,
        handleTaskAllDays,
        DAYS
    } = data;

    const task = filteredTasks[index];
    if (!task) return null;

    const allDaysChecked = DAYS.every(day => task.days[day]);
    const someDaysChecked = DAYS.some(day => task.days[day]) && !allDaysChecked;

    return (
        <div style={style}>
            <Box
                sx={{
                    display: 'flex',
                    borderBottom: '1px solid rgba(224, 224, 224, 0.5)',
                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                    height: '100%',
                    alignItems: 'center'
                }}
            >
                <Box sx={{ width: '60px', p: '6px 8px', fontSize: '0.875rem', flexShrink: 0 }}>
                    {index + 1}
                </Box>
                <Box sx={{ width: '150px', p: '6px 8px', fontSize: '0.875rem', flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <Tooltip title={task.yojanaName} arrow>
                        {task.yojanaName}
                    </Tooltip>
                </Box>
                <Box sx={{ width: '120px', p: '6px 8px', fontSize: '0.875rem', flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {task.workStationName || '—'}
                </Box>
                <Box sx={{ width: '120px', p: '6px 8px', fontSize: '0.875rem', flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {task.areaName}
                </Box>
                <Box sx={{ width: '200px', p: '6px 8px', fontSize: '0.875rem', flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {task.taskName}
                </Box>
                <Box sx={{ width: '50px', p: '6px 8px', display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
                    <MemoizedCheckbox
                        checked={allDaysChecked}
                        indeterminate={someDaysChecked}
                        onChange={(e) => handleTaskAllDays(index, e.target.checked)}
                        disabled={isFormDisabled}
                    />
                </Box>
                {DAYS.map(day => (
                    <Box
                        key={day}
                        sx={{
                            width: '50px',
                            p: '6px 2px',
                            display: 'flex',
                            justifyContent: 'center',
                            flexShrink: 0
                        }}
                    >
                        <MemoizedCheckbox
                            checked={!!task.days[day]}
                            onChange={(e) => handleDayCheck(index, day, e.target.checked)}
                            disabled={isFormDisabled}
                        />
                    </Box>
                ))}
                <Box sx={{ width: '200px', p: '6px 8px', fontSize: '0.875rem', flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <Tooltip title={task.taskRemark} arrow>
                        {task.taskRemark}
                    </Tooltip>
                </Box>
            </Box>
        </div>
    );
});

const Weeklystation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const globalProperty = useSelector(selectGlobalProperty);
    const contentRef = useRef(null);
    const yojanaNameRef = useRef(null);
    const [shiftData, setShiftData] = useState([]);
    const [dropdownData, setDropdownData] = useState([]);
    const [yojna, setYojna] = useState([]);
    const [area, setArea] = useState([]);
    const [task, setTask] = useState([]);
    const [rows, setRows] = useState([]);
    const [processedTasks, setProcessedTasks] = useState([]);
    const [filteredTasks, setFilteredTasks] = useState([]);
    const [selectedWorkAreas, setSelectedWorkAreas] = useState([]);
    const [selectedYojnas, setSelectedYojnas] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [selectedTasks, setSelectedTasks] = useState([]);
    const [formData, setFormData] = useState({
        YojanaName: '',
        Abrv: '',
        Remark: '',
        Property: '',
        Shift: '',
        Yojna: '',
        Area: '',
        Task: '',
    });

    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentYojana, setCurrentYojana] = useState(null);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [lastInsertedYojanaId, setLastInsertedYojanaId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [isRetrieveLoading, setIsRetrieveLoading] = useState(false);
    const [isPreviousDisabled, setIsPreviousDisabled] = useState(false);
    const [isNextDisabled, setIsNextDisabled] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    const processWeeklyData = useCallback((apiData) => {
        if (!apiData || apiData.length === 0) return [];

        const groupedData = {};

        apiData.forEach(item => {
            const yojanaName = item.YojanaName;
            const areaId = item.HkWrkAreaId;
            const areaName = item.HkWrkAreaName;
            const taskId = item.HkTaskId;
            const taskName = item.HkTaskName;
            const wrkAllocId = item.WrkAllocId || 0;
            const wrkAllocTaskId = item.WrkAllocTaskId || 0;
            const workStationName = item.HkWrkStnName || '—';
            const taskRemark = item.Remark || '-';

            const key = `${yojanaName}_${areaId}_${taskId}`;

            if (!groupedData[key]) {
                groupedData[key] = {
                    yojanaName: yojanaName,
                    yojanaId: item.YojanaId,
                    areaName: areaName,
                    areaId: areaId,
                    taskName: taskName,
                    taskId: taskId,
                    wrkAllocId: wrkAllocId,
                    wrkAllocTaskId: wrkAllocTaskId,
                    workStationName: workStationName,
                    taskRemark: taskRemark,
                    originalData: item,
                    days: {
                        Sun: item.Sun === "1",
                        Mon: item.Mon === "1",
                        Tue: item.Tue === "1",
                        Wed: item.Wed === "1",
                        Thu: item.Thu === "1",
                        Fri: item.Fri === "1",
                        Sat: item.Sat === "1"
                    }
                };
            }
        });

        return Object.values(groupedData);
    }, []);

    useEffect(() => {
        if (rows.length > 0) {
            const processedData = processWeeklyData(rows);
            setProcessedTasks(processedData);
            setFilteredTasks(processedData);
        } else {
            setProcessedTasks([]);
            setFilteredTasks([]);
        }
    }, [rows, processWeeklyData]);

    useEffect(() => {
        if (debouncedSearchTerm.trim() === '') {
            setFilteredTasks(processedTasks);
        } else {
            const searchTermLower = debouncedSearchTerm.toLowerCase().trim();
            const filtered = processedTasks.filter(task => {
                return (
                    task.yojanaName.toLowerCase().includes(searchTermLower) ||
                    task.taskName.toLowerCase().includes(searchTermLower) ||
                    task.areaName.toLowerCase().includes(searchTermLower) ||
                    task.workStationName.toLowerCase().includes(searchTermLower)
                );
            });
            setFilteredTasks(filtered);
        }
    }, [debouncedSearchTerm, processedTasks]);


    const processedTasksMap = useMemo(() => {
        const map = new Map();
        processedTasks.forEach((task, index) => {
            const key = `${task.yojanaName}_${task.areaName}_${task.taskName}`;
            map.set(key, { ...task, index });
        });
        return map;
    }, [processedTasks]);

    // Find task in processed array using Map
    const findTaskInProcessed = useCallback((filteredTask) => {
        const key = `${filteredTask.yojanaName}_${filteredTask.areaName}_${filteredTask.taskName}`;
        const task = processedTasksMap.get(key);
        return task ? task.index : -1;
    }, [processedTasksMap]);

    // Checkbox Handlers
    const handleDayCheck = useCallback((filteredIndex, day, checked) => {
        const filteredTask = filteredTasks[filteredIndex];
        if (!filteredTask) return;

        const processedIndex = findTaskInProcessed(filteredTask);
        if (processedIndex === -1) return;

        setProcessedTasks(prev => {
            const updated = [...prev];
            updated[processedIndex] = {
                ...updated[processedIndex],
                days: {
                    ...updated[processedIndex].days,
                    [day]: checked
                }
            };
            return updated;
        });
    }, [filteredTasks, findTaskInProcessed]);

    const handleTaskAllDays = useCallback((filteredIndex, checked) => {
        const filteredTask = filteredTasks[filteredIndex];
        if (!filteredTask) return;

        const processedIndex = findTaskInProcessed(filteredTask);
        if (processedIndex === -1) return;

        setProcessedTasks(prev => {
            const updated = [...prev];
            updated[processedIndex] = {
                ...updated[processedIndex],
                days: DAYS.reduce((acc, day) => {
                    acc[day] = checked;
                    return acc;
                }, {})
            };
            return updated;
        });
    }, [filteredTasks, findTaskInProcessed]);

    const handleAllTasksAllDays = useCallback((checked) => {
        setProcessedTasks(prev => {
            const updated = [...prev];

            filteredTasks.forEach(filteredTask => {
                const taskIndex = findTaskInProcessed(filteredTask);
                if (taskIndex !== -1) {
                    updated[taskIndex] = {
                        ...updated[taskIndex],
                        days: DAYS.reduce((acc, day) => {
                            acc[day] = checked;
                            return acc;
                        }, {})
                    };
                }
            });

            return updated;
        });
    }, [filteredTasks, findTaskInProcessed]);

    const handleAllTasksForDay = useCallback((day, checked) => {
        setProcessedTasks(prev => {
            const updated = [...prev];

            filteredTasks.forEach(filteredTask => {
                const taskIndex = findTaskInProcessed(filteredTask);
                if (taskIndex !== -1) {
                    updated[taskIndex] = {
                        ...updated[taskIndex],
                        days: {
                            ...updated[taskIndex].days,
                            [day]: checked
                        }
                    };
                }
            });

            return updated;
        });
    }, [filteredTasks, findTaskInProcessed]);

    const handleSearch = useCallback((event) => {
        setSearchTerm(event.target.value);
    }, []);

    const clearSearch = useCallback(() => {
        setSearchTerm('');
    }, []);

    const allTasksAllDaysChecked = useMemo(() => {
        return filteredTasks.length > 0 &&
            filteredTasks.every(task => DAYS.every(day => task.days[day]));
    }, [filteredTasks]);

    const allTasksAllDaysIndeterminate = useMemo(() => {
        return filteredTasks.length > 0 &&
            filteredTasks.some(task => DAYS.some(day => task.days[day])) &&
            !filteredTasks.every(task => DAYS.every(day => task.days[day]));
    }, [filteredTasks]);

    const dayCheckStates = useMemo(() => {
        const states = {};
        DAYS.forEach(day => {
            states[day] = {
                checked: processedTasks.length > 0 && processedTasks.every(task => task.days[day]),
                indeterminate: processedTasks.length > 0 &&
                    processedTasks.some(task => task.days[day]) &&
                    !processedTasks.every(task => task.days[day])
            };
        });
        return states;
    }, [processedTasks]);


    useEffect(() => {
        const getYojnaMasteTaskdrp = async () => {
            try {
                const response = await axiosInstanceForPG.post(
                    '/MstHkTask/getMstHkTaskdrp', {}
                );

                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data
                        .filter(item =>
                            item.Id &&
                            item.Name &&
                            item.Id.toString().trim() !== '' &&
                            item.Name.toString().trim() !== '' &&
                            item.Name !== null &&
                            item.Id !== null
                        )
                        .map((item) => ({
                            id: item.Id,
                            name: item.Name,
                        }));

                    setTask(dropdownItems);

                    if (dropdownItems.length > 0) {
                        setFormData(prev => ({ ...prev, Task: dropdownItems[0].id.toString() }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching task data");
            }
        };
        getYojnaMasteTaskdrp();
    }, []);

    useEffect(() => {
        const fetchYojnaData = async () => {
            try {
                const response = await getYojnaMasterdropdata({
                    Flag: "",
                    YojanaId: 1
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.YojanaId,
                        name: item.YojanaName,
                    }));
                    setYojna(dropdownItems);
                    if (dropdownItems.length > 0) {
                        setFormData(prev => ({ ...prev, Yojna: dropdownItems[0].id }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching yojna data");
            }
        };
        fetchYojnaData();
    }, []);

    useEffect(() => {
        const fetchAreaData = async () => {
            try {
                const response = await getYojnaMastearedrp({
                    Flag: "",
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.HkWrkAreaId,
                        name: item.HkWrkAreaName,
                    }));
                    setArea(dropdownItems);
                    if (dropdownItems.length > 0) {
                        setFormData(prev => ({ ...prev, Area: dropdownItems[0].id }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching area data");
            }
        };
        fetchAreaData();
    }, []);

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const response = await getRoomMasterdropdata({
                    Flag: "",
                    UserId: userId,
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data?.map((item) => ({
                        id: item.PropId,
                        name: item.Name,
                    }));
                    setDropdownData(dropdownItems);
                    if (globalProperty) {
                        const globalPropExists = dropdownItems.find(item =>
                            item.id.toString() === globalProperty.toString()
                        );

                        if (globalPropExists) {
                            setFormData(prev => ({
                                ...prev,
                                Property: globalProperty.toString()
                            }));
                        } else if (dropdownItems.length > 0) {
                            setFormData(prev => ({
                                ...prev,
                                Property: dropdownItems[0].id.toString()
                            }));
                        }
                    } else if (dropdownItems.length > 0) {
                        setFormData(prev => ({
                            ...prev,
                            Property: dropdownItems[0].id.toString()
                        }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching property data");
            }
        };
        fetchDropdownData();
    }, [userId]);

    useEffect(() => {
        const fetchShiftData = async () => {
            try {
                const response = await getShiftMasterdropdata();
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.ShiftId,
                        name: item.ShiftName,
                    }));
                    setShiftData(dropdownItems);
                    if (dropdownItems.length > 0) {
                        setFormData(prev => ({ ...prev, Shift: dropdownItems[0].id }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching shift data");
            }
        };
        fetchShiftData();
    }, []);

    useEffect(() => {
        if (globalProperty && globalProperty !== formData.Property) {
            setFormData(prevState => ({
                ...prevState,
                Property: globalProperty.toString()
            }));
        }
    }, [globalProperty]);


    useEffect(() => {
        if (location.state?.YojanaId && location.state?.PropId && location.state?.ShiftId) {
            const propId = location.state.PropId.toString();
            const shiftId = location.state.ShiftId.toString();
            const yojanaId = location.state.YojanaId.toString();

            setFormData(prev => ({
                ...prev,
                Property: propId,
                Shift: shiftId,
                Yojna: yojanaId,
            }));

            setCurrentYojana(location.state.YojanaId);
            setMode('view');
            setIsFormDisabled(true);
        } else if (!location.state) {
            setMode('add');
            setIsFormDisabled(false);
            setSelectedWorkAreas([]);
            setRows([]);
            setProcessedTasks([]);
            setFilteredTasks([]);
            clearSearch();
        }
    }, [location.state, clearSearch]);

    useEffect(() => {
        if (shiftData.length > 0 && location.state?.ShiftId) {
            const correctShift = shiftData.find(item => item.id === location.state.ShiftId);
            if (correctShift) {
                setFormData(prev => ({ ...prev, Shift: correctShift.id.toString() }));
            }
        }
    }, [shiftData, location.state?.ShiftId]);

    useEffect(() => {
        if (yojna.length > 0 && location.state?.YojanaId) {
            const correctYojna = yojna.find(item => item.id === location.state.YojanaId);
            if (correctYojna) {
                setFormData(prev => ({ ...prev, Yojna: correctYojna.id.toString() }));
            }
        }
    }, [yojna, location.state?.YojanaId]);

    useEffect(() => {
        if (dropdownData.length > 0 && location.state?.PropId) {
            const correctProp = dropdownData.find(item => item.id === location.state.PropId);
            if (correctProp) {
                setFormData(prev => ({ ...prev, Property: correctProp.id.toString() }));
            }
        }
    }, [dropdownData, location.state?.PropId]);

    const deleteYojanaData = async (id) => {
        try {
            const response = await axiosInstance.post(`MstYojana/DeleteMstYojana`, {
                YojanaId: parseInt(id),
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || 'Data deleted successfully.');
                return true;
            } else {
                toast.info(response.data.Message || 'Failed to delete record.');
                return false;
            }
        } catch (error) {
            toast.error('Error while deleting yojana.');
            return false;
        }
    };

    const handlePrevious = async () => {
        if (currentYojana && currentYojana > 1 && !isPreviousDisabled) {
            await handleRetrieve();
        }
    };

    const handleNext = async () => {
        if (currentYojana && !isNextDisabled) {
            await handleRetrieve();
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            Yojna: '',
            Area: '',
            Task: ''
        }));
    }, []);

    const handleRetrieve = async () => {
        if (!formData.Property) {
            toast.error('Property is required');
            return;
        }
        if (!formData.Shift) {
            toast.error('Shift is required');
            return;
        }

        setIsRetrieveLoading(true);
        setRows([]);
        setSelectedWorkAreas([]);
        setProcessedTasks([]);
        setFilteredTasks([]);
        clearSearch();

        try {
            const payload = {
                PropId: parseInt(formData.Property),
                YojanaId: 1,
                ShiftId: parseInt(formData.Shift),
                HkWrkAreaId: 1,
                StrHkTaskId: selectedTasks.length > 0 ? selectedTasks.join(',') : '',
                StrYojanaId: selectedYojnas.length > 0 ? selectedYojnas.join(',') : '',
                StrHkWrkAreaId: selectedAreas.length > 0 ? selectedAreas.join(',') : ''
            };

            const response = await axiosInstance.post(
                'MstYojana/RetriveMstYojanaWiseAreaWeek',
                payload
            );

            if (response.data?.Status === 0 && response.data?.Data?.length > 0) {
                setRows(response.data.Data);
            } else {
                setRows([]);
                toast.info(response.data?.Message || "No data found for this combination");
            }
        } catch (error) {
            toast.error("Error loading data");
            setRows([]);
        } finally {
            setIsRetrieveLoading(false);
        }
    };

    const handleSubmit = async () => {
        if (processedTasks.length === 0) {
            toast.error('No data to submit');
            return;
        }

        setIsSubmitting(true);
        const submissionData = [];
        const groupedTasks = {};

        processedTasks.forEach(task => {
            const originalData = rows.find(row =>
                row.YojanaName === task.yojanaName &&
                row.HkWrkAreaName === task.areaName &&
                row.HkTaskName === task.taskName
            );

            if (originalData) {
                const key = `${originalData.YojanaId}_${originalData.HkWrkAreaId}`;

                if (!groupedTasks[key]) {
                    groupedTasks[key] = {
                        WrkAllocId: originalData.WrkAllocId || 0,
                        PropId: parseInt(formData.Property),
                        HkWrkAreaId: originalData.HkWrkAreaId,
                        YojanaId: originalData.YojanaId,
                        ShiftId: parseInt(formData.Shift),
                        MstYojanaEntities: []
                    };
                }

                groupedTasks[key].MstYojanaEntities.push({
                    WrkAllocId: originalData.WrkAllocId || 0,
                    HkTaskId: originalData.HkTaskId,
                    Sun: task.days.Sun ? "1" : "0",
                    Mon: task.days.Mon ? "1" : "0",
                    Tue: task.days.Tue ? "1" : "0",
                    Wed: task.days.Wed ? "1" : "0",
                    Thu: task.days.Thu ? "1" : "0",
                    Fri: task.days.Fri ? "1" : "0",
                    Sat: task.days.Sat ? "1" : "0"
                });
            }
        });

        Object.keys(groupedTasks).forEach(key => {
            submissionData.push(groupedTasks[key]);
        });

        try {
            const response = await axiosInstance.post(
                'MstYojana/MangeMstWrkAlloc',
                submissionData
            );

            if (response.data.Status === 0) {
                toast.success(response.data.Message || 'Data submitted successfully');
                await handleRetrieve();
                setMode('view');
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Submission failed');
            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error('Error submitting data');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentYojana, "MstYojana", "YojanaId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setCurrentYojana(null);
        setStatus("1");
        setSelectedWorkAreas([]);
        setRows([]);
        setProcessedTasks([]);
        setFilteredTasks([]);
        clearSearch();

        setTimeout(() => {
            yojanaNameRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            if (mode === 'edit' && currentYojana) {
                await UnLock(currentYojana, "MstYojana", "YojanaId");
            }
            setMode('view');
            setIsFormDisabled(true);
            if (rows.length > 0) {
                const processedData = processWeeklyData(rows);
                setProcessedTasks(processedData);
                setFilteredTasks(processedData);
            }
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/masters/operations');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handlePrint = useReactToPrint({
        contentRef: contentRef,
        documentTitle: `Weekly_Allocation_Report_${new Date().toISOString().split('T')[0]}`,
    });

    const itemData = useMemo(() => ({
        filteredTasks,
        isFormDisabled,
        handleDayCheck,
        handleTaskAllDays,
        DAYS
    }), [filteredTasks, isFormDisabled, handleDayCheck, handleTaskAllDays]);

    const rowHeight = 30;

    const handleYojnaMultiSelect = (event) => {
        const { value } = event.target;
        setSelectedYojnas(typeof value === 'string' ? value.split(',') : value);
        setFormData(prev => ({ ...prev, Yojna: value.join(',') }));
    };

    const handleAreaMultiSelect = (event) => {
        const { value } = event.target;
        setSelectedAreas(typeof value === 'string' ? value.split(',') : value);
        setFormData(prev => ({ ...prev, Area: value.join(',') }));
    };

    const handleTaskMultiSelect = (event) => {
        const { value } = event.target;
        setSelectedTasks(typeof value === 'string' ? value.split(',') : value);
        setFormData(prev => ({ ...prev, Task: value.join(',') }));
    };

    return (
        <>
            <Box className="form-container" sx={{
                width: { xs: "calc(100vw )", sm: "auto", md: "auto" },
                maxWidth: { xs: "calc(100vw )", sm: "auto", md: "auto" },
            }}>
                <ToastContainer />

                <Grid container spacing={1} className="form_grid" sx={{ width: '90% !important', minHeight: '90% !important' }}>
                    <Grid item xs={12} className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' },
                                fontWeight: 'bold',
                                color: '#333'
                            }}
                        >
                            Weekly Allocation/Task
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Yojana Allocate to SubStation"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                                hideEdit={true}
                                hideDelete={true}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field" mt={0.5}>
                        <Box sx={{ width: '100%' }}>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield" size="small">
                                        <InputLabel id="property-label">Property</InputLabel>
                                        <Select
                                            labelId="property-label"
                                            id="Property"
                                            name="Property"
                                            value={formData.Property}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                        >
                                            {dropdownData.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield" size="small">
                                        <InputLabel id="shift-label">Shift</InputLabel>
                                        <Select
                                            labelId="shift-label"
                                            id="Shift"
                                            name="Shift"
                                            value={formData.Shift || ''}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                        >
                                            {shiftData.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* <Grid item xs={12} md={5}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield">
                                        <InputLabel id="yojna-multi-label">Yojna Name</InputLabel>
                                        <Select
                                            labelId="yojna-multi-label"
                                            id="Yojna"
                                            name="Yojna"
                                            multiple
                                            value={selectedYojnas}
                                            onChange={handleYojnaMultiSelect}
                                            disabled={isFormDisabled}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return <em>Select Yojna(s)</em>;
                                                }
                                                return selected.map(id => {
                                                    const item = yojna.find(item => item.id.toString() === id.toString());
                                                    return item?.name || id;
                                                }).join(', ');
                                            }}
                                            MenuProps={MenuProps}
                                        >
                                            {yojna.map((item) => (
                                                <MenuItem key={item.id} value={item.id.toString()}>
                                                    <Checkbox checked={selectedYojnas.indexOf(item.id.toString()) > -1} sx={{ padding: "2px" }} />
                                                    <ListItemText primary={item.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid> */}

                                {/* <Grid item xs={12} md={2.3}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield">
                                        <InputLabel id="area-multi-label">Area Name</InputLabel>
                                        <Select
                                            labelId="area-multi-label"
                                            id="Area"
                                            name="Area"
                                            multiple
                                            value={selectedAreas}
                                            onChange={handleAreaMultiSelect}
                                            disabled={isFormDisabled}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return <em>Select Area(s)</em>;
                                                }
                                                return selected.map(id => {
                                                    const item = area.find(item => item.id.toString() === id.toString());
                                                    return item?.name || id;
                                                }).join(', ');
                                            }}
                                            MenuProps={MenuProps}
                                        >
                                            {area.map((item) => (
                                                <MenuItem key={item.id} value={item.id.toString()}>
                                                    <Checkbox checked={selectedAreas.indexOf(item.id.toString()) > -1} />
                                                    <ListItemText primary={item.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={2.3}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield">
                                        <InputLabel id="task-multi-label">Task Name</InputLabel>
                                        <Select
                                            labelId="task-multi-label"
                                            id="Task"
                                            name="Task"
                                            multiple
                                            value={selectedTasks}
                                            onChange={handleTaskMultiSelect}
                                            disabled={isFormDisabled}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return <em>Select Task(s)</em>;
                                                }
                                                return selected.map(id => {
                                                    const item = task.find(item => item.id.toString() === id.toString());
                                                    return item?.name || id;
                                                }).join(', ');
                                            }}
                                            MenuProps={MenuProps}
                                             displayEmpty={false} 
                                        >
                                            {task.map((item) => (
                                                <MenuItem key={item.id} value={item.id.toString()}>
                                                    <Checkbox checked={selectedTasks.indexOf(item.id.toString()) > -1} />
                                                    <ListItemText primary={item.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid> */}

                                <Grid item xs={12} md={1}>
                                    <Button
                                        size='small'
                                        variant="contained"
                                        onClick={handleRetrieve}
                                        disabled={isRetrieveLoading || isFormDisabled}
                                        sx={{
                                            bgcolor: '#635bff',
                                            '&:hover': { bgcolor: '#5248cc' },
                                            padding: '8px 16px',
                                            fontSize: '0.75rem',
                                            minWidth: '80px',
                                            textTransform: 'none'
                                        }}
                                    >
                                        {isRetrieveLoading ? 'Loading...' : 'Retrieve'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                    {/* {processedTasks.length > 0 && ( */}
                    <Grid item xs={12} mt={0.5}>
                        <Paper sx={{
                            width: '100%',
                            overflow: 'hidden',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            borderRadius: '8px',
                            minHeight: '400px'
                        }}>
                            <Box sx={{
                                p: 0.2,
                                pt: 0,
                                pb: 1,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                backgroundColor: '#f8f9fa',
                                borderBottom: '1px solid #e0e0e0',
                                minHeight: '40px'
                            }}>
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth className="custom-textfield">
                                        <InputLabel id="yojna-multi-label">Yojna Name</InputLabel>
                                        <Select
                                            labelId="yojna-multi-label"
                                            id="Yojna"
                                            name="Yojna"
                                            multiple
                                            value={selectedYojnas}
                                            onChange={handleYojnaMultiSelect}
                                            disabled={isFormDisabled}
                                            renderValue={(selected) => {
                                                if (selected.length === 0) {
                                                    return <em>Select Yojna(s)</em>;
                                                }
                                                return selected.map(id => {
                                                    const item = yojna.find(item => item.id.toString() === id.toString());
                                                    return item?.name || id;
                                                }).join(', ');
                                            }}
                                            MenuProps={MenuProps}
                                        >
                                            {yojna.map((item) => (
                                                <MenuItem key={item.id} value={item.id.toString()}>
                                                    <Checkbox checked={selectedYojnas.indexOf(item.id.toString()) > -1} sx={{ padding: "2px" }} />
                                                    <ListItemText primary={item.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <TextField
                                    size="small"
                                    placeholder="Search by Yojana, Task or Work Area..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon sx={{ fontSize: '1rem', color: '#666' }} />
                                            </InputAdornment>
                                        ),
                                        endAdornment: searchTerm && (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    size="small"
                                                    onClick={clearSearch}
                                                    edge="end"
                                                    sx={{ padding: '2px' }}
                                                >
                                                    <CloseIcon sx={{ fontSize: '0.95rem' }} />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    disabled={isFormDisabled || processedTasks.length === 0}
                                    sx={{
                                        width: '300px',
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            '&:hover': {
                                                backgroundColor: 'white',
                                            },
                                            '& input': {
                                                padding: '6px 14px',
                                                fontSize: '0.8rem'
                                            }
                                        }
                                    }}
                                />
                                <Typography variant="caption" sx={{ color: '#666', fontSize: '0.75rem' }}>
                                    Showing {filteredTasks.length} of {processedTasks.length} tasks
                                </Typography>
                            </Box>

                            <Box sx={{
                                borderBottom: '1px solid #dee2e6',
                                backgroundColor: '#f0f0f0',
                            }}>

                                <Box sx={{
                                    display: 'flex',
                                    backgroundColor: '#e9ecef',
                                    fontWeight: 600,
                                    fontSize: '0.8rem',
                                    borderBottom: '1px solid #ced4da',
                                    '& > div': {
                                        padding: '6px 8px',
                                        borderRight: '1px solid #dee2e6',
                                        '&:last-child': { borderRight: 'none' }
                                    }
                                }}>
                                    <Box sx={{ width: '60px', flexShrink: 0 }}>Sr No.</Box>
                                    <Box sx={{ width: '150px', flexShrink: 0 }}>Yojana</Box>
                                    <Box sx={{ width: '120px', flexShrink: 0 }}>Work Station</Box>
                                    <Box sx={{ width: '120px', flexShrink: 0 }}>Work Area</Box>
                                    <Box sx={{ width: '200px', flexShrink: 0 }}>Task</Box>
                                    <Box sx={{ width: '50px', flexShrink: 0, textAlign: 'center' }}>
                                        All
                                    </Box>
                                    {DAYS.map(day => (
                                        <Box key={day} sx={{ width: '50px', flexShrink: 0, textAlign: 'center' }}>
                                            {day}
                                        </Box>
                                    ))}
                                    <Box sx={{ width: '250px', flexShrink: 0 }}>Task Remark</Box>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    backgroundColor: '#bfddfa',
                                    fontSize: '0.75rem',
                                    '& > div': {
                                        padding: '2px 8px',
                                        borderRight: '1px solid #dee2e6',
                                        '&:last-child': { borderRight: 'none' }
                                    }
                                }}>
                                    <Box sx={{ width: '60px', flexShrink: 0 }}></Box>
                                    <Box sx={{ width: '150px', flexShrink: 0 }}></Box>
                                    <Box sx={{ width: '120px', flexShrink: 0 }}></Box>
                                    <Box sx={{ width: '120px', flexShrink: 0 }}></Box>
                                    <Box sx={{ width: '200px', flexShrink: 0 }}></Box>
                                    <Box sx={{ width: '50px', flexShrink: 0, display: 'flex', justifyContent: 'center' }}>
                                        <MemoizedCheckbox
                                            checked={allTasksAllDaysChecked}
                                            indeterminate={allTasksAllDaysIndeterminate}
                                            onChange={(e) => handleAllTasksAllDays(e.target.checked)}
                                            disabled={isFormDisabled}
                                        />
                                    </Box>
                                    {DAYS.map(day => (
                                        <Box key={day} sx={{ width: '50px', flexShrink: 0, display: 'flex', justifyContent: 'center' }}>
                                            <MemoizedCheckbox
                                                checked={dayCheckStates[day]?.checked || false}
                                                indeterminate={dayCheckStates[day]?.indeterminate || false}
                                                onChange={(e) => handleAllTasksForDay(day, e.target.checked)}
                                                disabled={isFormDisabled}
                                            />
                                        </Box>
                                    ))}
                                    <Box sx={{ width: '250px', flexShrink: 0 }}></Box>
                                </Box>
                            </Box>

                            {filteredTasks.length > 0 ? (
                                <Box sx={{
                                    height: Math.min(370, filteredTasks.length * rowHeight + 2),
                                    width: '100%',
                                    '&::-webkit-scrollbar': {
                                        width: '8px',
                                        height: '5px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '4px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    },
                                }}>
                                    <AutoSizer>
                                        {({ height, width }) => (
                                            <List
                                                height={height}
                                                itemCount={filteredTasks.length}
                                                itemSize={rowHeight}
                                                width={width}
                                                itemData={itemData}
                                                overscanCount={5}
                                            >
                                                {TaskRow}
                                            </List>
                                        )}
                                    </AutoSizer>
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        py: 6,
                                        textAlign: 'center',
                                        backgroundColor: '#f9fafb',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 2,
                                    }}
                                >
                                    {/* <HourglassEmptyIcon
                                        sx={{
                                            fontSize: 60,
                                            color: '#a0aec0',
                                            animation: `${rotate360} 2s linear infinite`,
                                        }}
                                    /> */}
                                    <Typography
                                        variant="body1"
                                        sx={{ fontSize: '1rem', color: '#6b7280', maxWidth: 400 }}
                                    >
                                        No tasks found matching. Select <strong>Property</strong>, <strong>Shift</strong>, and <strong>Yojna</strong> filters, then click{' '}
                                        <strong>RETRIEVE</strong> to load tasks.
                                    </Typography>
                                </Box>
                            )}
                        </Paper>
                    </Grid>
                    {/* )} */}

                    <Grid item xs={12} className="form_button" mt={1} >
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: 'linear-gradient(290deg, #c9f0f3, #5d82ac)',
                                        padding: '6px 20px',
                                        fontSize: '0.8rem',
                                        fontWeight: 500,
                                        '&:hover': {
                                            background: 'linear-gradient(290deg, #b8e3e6, #4c6e94)'
                                        }
                                    }}
                                    onClick={handleAdd}
                                >
                                    Add New
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: 'linear-gradient(290deg, #a7c5e9, #8fabf3)',
                                        padding: '6px 20px',
                                        fontSize: '0.8rem',
                                        fontWeight: 500,
                                        '&:hover': {
                                            background: 'linear-gradient(290deg, #94b2d6, #7e9ae1)'
                                        }
                                    }}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #b9d0e9, #8aafcf)",
                                        padding: '6px 20px',
                                        fontSize: '0.8rem',
                                        fontWeight: 500,
                                        '&:hover': {
                                            background: "linear-gradient(290deg, #a6bdd6, #7a9cb8)"
                                        }
                                    }}
                                    onClick={handleSubmit}
                                    disabled={processedTasks.length === 0 || isSubmitting}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #b9d0e9, #608fb8)",
                                        padding: '6px 20px',
                                        fontSize: '0.8rem',
                                        fontWeight: 500,
                                        '&:hover': {
                                            background: "linear-gradient(290deg, #a6bdd6, #4f7a9e)"
                                        }
                                    }}
                                    onClick={handleCancel}
                                // disabled={isSubmitting}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                <WeeklywisePrint
                    ref={contentRef}
                    processedTasks={filteredTasks.length > 0 ? filteredTasks : processedTasks}
                    propertyName={
                        dropdownData.length > 0 && formData.Property
                            ? dropdownData.find(item =>
                                item.id.toString() === formData.Property.toString()
                            )?.name || 'N/A'
                            : 'N/A'
                    }
                    shiftName={
                        shiftData.length > 0 && formData.Shift
                            ? shiftData.find(item =>
                                item.id.toString() === formData.Shift.toString()
                            )?.name || 'N/A'
                            : 'N/A'
                    }
                    searchCriteria={searchTerm}
                    title="Weekly Task Allocation Report"
                />
            </div>
        </>
    );
};

export default Weeklystation;